import store from "@/store";
const directorAuth = (to, from, next) => {
  if (!store.getters.isDirectorAuthenticated) {
    // 아직 로그인이 안 되있는 유저니까 막아야 한다.
    alert("로그인이 필요합니다");
    next("/director/loginDo");
  } else {
    next();
  }
};
const funeralAuth = (to, from, next) => {
  if (!store.getters.isFuneralAuthenticated) {
    // 아직 로그인이 안 되있는 유저니까 막아야 한다.
    alert("로그인이 필요합니다");
    next("/funeral/loginDo");
  } else {
    next();
  }
};

const corpAuth = (to, from, next) => {
  let access_token = localStorage.getItem("access_token");

  if (!store.getters.isCorpAuthenticated || !access_token) {
    // 아직 로그인이 안 되있는 유저니까 막아야 한다.
    alert("로그인이 필요합니다");
    next("/corp/loginDo");
  } else {
    next();
  }
};

export default [
  {
    meta: {
      title: "Movie"
    },
    path: "/director/movie",
    name: "Movie",
    beforeEnter: directorAuth,
    component: () => import("@/views/director/movie/Movie.vue")
  },
  {
    meta: {
      title: "MovieDetail"
    },
    path: "/director/movie-detail",
    name: "MovieDetail",
    beforeEnter: directorAuth,
    component: () => import("@/views/director/movie/MovieDetail.vue")
  },
  {
    meta: {
      title: "MovieComplete"
    },
    path: "/director/movie-complete",
    name: "MovieComplete",
    beforeEnter: directorAuth,
    component: () => import("@/views/director/movie/MovieComplete.vue")
  },
  {
    meta: {
      title: "Movie"
    },
    path: "/funeral/movie",
    name: "Movie",
    beforeEnter: funeralAuth,
    component: () => import("@/views/funeral/movie/Movie.vue")
  },
  {
    meta: {
      title: "MovieDetail"
    },
    path: "/funeral/movie-detail",
    name: "MovieDetail",
    beforeEnter: funeralAuth,
    component: () => import("@/views/funeral/movie/MovieDetail.vue")
  },

  {
    meta: {
      title: "MovieComplete"
    },
    path: "/funeral/movie-complete",
    name: "MovieComplete",
    beforeEnter: funeralAuth,
    component: () => import("@/views/funeral/movie/MovieComplete.vue")
  },
  {
    meta: {
      title: "Movie"
    },
    path: "/corp/movie",
    name: "Movie",
    beforeEnter: corpAuth,
    component: () => import("@/views/corp/movie/Movie.vue")
  },
  {
    meta: {
      title: "MovieDetail"
    },
    path: "/corp/movie-detail",
    name: "MovieDetail",
    beforeEnter: corpAuth,
    component: () => import("@/views/corp/movie/MovieDetail.vue")
  },

  {
    meta: {
      title: "MovieComplete"
    },
    path: "/corp/movie-complete",
    name: "MovieComplete",
    beforeEnter: corpAuth,
    component: () => import("@/views/corp/movie/MovieComplete.vue")
  }
];
